document.addEventListener('click', (e) => {
    const select = e.target.closest('.select');
    document.querySelectorAll('.select').forEach((el) => {
        el.classList.toggle('select--active', el === select && !el.classList.contains('select--active'));
    });
});
